import { render, staticRenderFns } from "./StickForm.vue?vue&type=template&id=ddd45344&"
import script from "./StickForm.vue?vue&type=script&lang=js&"
export * from "./StickForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports